<template>
    <CicPopup
        id="access_revisions"
        :title="$t('Access Point [x]').replace(/\[x]/g, item.name)"
        class="no-padding"
        @blur="$emit('blur')"
    >
        <div v-if="$store.showLoadingOverlay" class="cloud-overlay"></div>
        <table v-else class="cic-table">
            <thead>
                <tr>
                    <th class="th-checkbox">{{ $t('Active') }}</th>
                    <th>{{ $t('Version') }}</th>
                    <th>{{ $t('Primary Route Plan') }}</th>
                    <th>{{ $t('Revision Date') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="revision in revisions">
                    <td class="td-checkbox">
                        <CicCheckbox
                            :enabled="item.revision !== revision.revisionId"
                            :value="item.revision === revision.revisionId"
                            @click="handleClick(revision.revisionId)"
                        />
                    </td>
                    <td>{{ revision.revisionId }}</td>
                    <td>{{ revision.planName ? revision.planName : $t('None') }}</td>
                    <td>{{ revision.updated ? revision.updated : '' }}</td>
                </tr>
            </tbody>
        </table>
    </CicPopup>
</template>

<script>
    import moment from 'moment';
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import { load, save } from '@/utils/Http';

    export default {
        name: 'EditRevision',
        components: {
            CicCheckbox,
            CicPopup,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change'],
        data() {
            return {
                revisions: [],
            };
        },
        created() {
            this.loadRevisions();
        },
        methods: {
            loadRevisions() {
                load(
                    'accesspoint/revisions',
                    {
                        orgId: this.item.orgId,
                        accessId: this.item.accessId,
                        originationGroupId: this.item.originationGroupId,
                    },
                    (response) => {
                        this.revisions = response.revisions.map((revision) => ({
                            ...revision,
                            updated: revision.updated ? moment(revision.updated).format('YYYY-MM-DD HH:mm:ss') : null,
                        }));
                    },
                );
            },
            handleClick(revisionId) {
                if (confirm(this.$t('ACCESS_VERSION_CONFIRM'))) {
                    save(
                        'accesspoint/updaterevision',
                        { orgId: this.item.orgId, accessId: this.item.accessId, revisionId },
                        () => {
                            this.$emit('change');
                        },
                    );
                }
            },
        },
    };
</script>
